import * as React from 'react';
import { PdsIconX as PdsIconXElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconX = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-x',
  elementClass: PdsIconXElement,
  react: React,
});
